import React, { Component } from 'react';
import SurvivorChip from './SurvivorChip';

const getPositionClass = (place) => {
  if( place === '1st' ) return 'firstPlace'
  if( place === '2nd' ) return 'secondPlace'
  if( place === '3rd' ) return 'thirdPlace'
  if( place.length >= 3 )return 'loserPlace'
  return ''
}

class PlayerScore extends Component {
  render() {
    return (
      <table className="mdl-data-table">
          <tbody>
              <tr className={ getPositionClass(this.props.place) }>
                  <td>{ this.props.place }</td>
                  <td>{ this.props.player }</td>
                  <td><SurvivorChip key={ this.props.pick } name={ this.props.pick }/></td>
              </tr>
          </tbody>
      </table>
    )
  }
}

export default PlayerScore
